import React from 'react';
import moment from 'moment';
import getAnimalStatusColor from '../../../utils/getAnimalStatusColor';

import { IconLock } from '@tabler/icons';
import { Container, Image, Badge, SelectDot } from './styles';
import animalImg from '../../../assets/images/small-animal-example.png';

interface IAnimal {
  name: string;
  gender: string;
  number: string;
  birth: any;
  state: string;
  belongs: boolean;
  imageUrl?: string;
  isPrivate?: boolean;
  customStyle?: any;
  onClick?: () => void;
  ref?: any;
  selectable?: boolean;
  selected?: boolean;
}

const Item: React.FC<IAnimal> = ({
  name,
  gender,
  birth,
  number,
  imageUrl,
  customStyle,
  onClick,
  state,
  isPrivate,
  belongs,
  ref,
  selectable,
  selected,
}) => {
  return (
    <Container
      style={customStyle}
      onClick={onClick}
      isLinked={!!onClick}
      active={selected || false}
      ref={ref}
    >
      <div>
        {selectable && (
          <SelectDot active={selected || false}>
            <div />
          </SelectDot>
        )}

        <Image src={imageUrl || animalImg} alt="Animal" />
        <div className="info">
          <p>
            {gender === 'macho'
              ? 'Macho'
              : gender === 'femea'
              ? 'Fêmea'
              : 'Nulo'}{' '}
            -{' '}
            {birth
              ? typeof birth === 'number'
                ? birth
                : moment(birth.toString().replace('T00:00:00.000Z', '')).format(
                    'DD[/]MM[/]YYYY',
                  )
              : '00/00/0000'}
          </p>
          <strong>
            {isPrivate && (
              <IconLock
                size={20}
                color="var(--gray-9)"
                style={{ marginRight: 5, marginBottom: -3 }}
              />
            )}
            {name || '--'}
          </strong>
        </div>
      </div>

      <Badge
        style={{
          background: getAnimalStatusColor(belongs, state, gender),
        }}
      >
        Nº {number || '--'}
      </Badge>
    </Container>
  );
};

export default Item;
